<div class="login-page">
    <div class="login-hero" style="background-image: url('assets/img/hero/console.png')">
        <div class="login-overlay">
            <div class="login-left">
                <h1>Sign In/Sign Up</h1>
                <p>Welcome To Yogamez Hub</p>
            </div>
            <div class="login-card">
                <h2>Sign In</h2>
                <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                    <label>Phone number</label>
                    <span *ngIf="loginForm.get('identifier')?.errors?.['required'] && loginForm.get('identifier')?.touched"
                          class="error-text">
                        Phone number is required
                    </span>
                    <span *ngIf="loginForm.get('identifier')?.errors?.['isEconetSubscriber'] && loginForm.get('identifier')?.touched && loginForm.get('identifier')?.value!=''"
                          class="error-text">
                        Invalid Econet number. It must start with 077, 078, or 079 and have 10 digits.
                    </span>
                    <div class="input__item">
                        <span class="fa fa-user"></span>
                        <input type="text" placeholder="079XXXXXXX" formControlName="identifier" maxlength="10">
                    </div>

                    <label>Password</label>
                    <span *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
                          class="error-text">
                        Password is required
                    </span>
                    <div class="input__item">
                        <span class="fa fa-lock"></span>
                        <input [type]="isPasswordVisible ? 'text' : 'password'" placeholder="Enter Password"
                               formControlName="password">
                        <button class="toggle-password-btn" type="button" (click)="togglePasswordVisibility()">
                            <i *ngIf="isPasswordVisible" class="fa fa-eye-slash"></i>
                            <i *ngIf="!isPasswordVisible" class="fa fa-eye"></i>
                        </button>
                    </div>

                    <div *ngIf="isVerified">
                        <span *ngIf="noPhone" class="error-text">
                            *Provide valid phone number to get OTP
                        </span>
                        <span *ngIf="loginForm.get('otp')?.invalid && loginForm.get('otp')?.touched"
                              class="error-text">
                            OTP is required
                        </span>
                        <div class="input__item">
                            <span class="fa fa-keyboard-o"></span>
                            <input type="text" placeholder="OTP" formControlName="otp">
                            <button class="otp-password-btn" type="button" title="Resend OTP" (click)="getOTP()" [disabled]="isGettingOtp">
                                <i class="fa fa-refresh"></i>
                            </button>
                        </div>
                    </div>

                    <span *ngIf="!isVerified && noPhone" class="error-text">
                        *Provide valid phone number to get OTP
                    </span>

                    <div class="login-actions">
                        <button *ngIf="!isVerified" type="button" class="site-btn" (click)="getOTP()" [disabled]="isGettingOtp">
                            {{ isGettingOtp ? 'Getting OTP...' : 'Get OTP' }}
                        </button>
                        <button *ngIf="isVerified" type="submit" class="site-btn">Sign In</button>
                        <p>Don't have an account? <a (click)="routeToPage('/signup')">Sign Up!</a></p>
                    </div>

                    <a (click)="routeToPage('/resetpassword')" class="forget_password">Forgot Your Password?</a>
                </form>
            </div>
        </div>
    </div>
</div>
